module.exports = __webpack_public_path__ + "static/media/heidi-erickson-2Q9zeNBoxA8-unsplash.bfd8564f.jpg";